import Button from 'components/shared/Buttons/BaseButton';
import { getEnrollmentUrl } from 'utils/linkHelpers';

/** Owns its copy rather than taking it, so the offer cannot drift between result panels. */
export const CalculatorEnrollmentCta = () => (
  <div className="flex flex-col gap-2">
    <p className="text-heading-sm">Fee-free banking with Chime.</p>
    <p className="text-body-saans text-content-secondary">Start banking with Chime today.</p>
    {/* `Button href` already fires the enrollment CTA event through `Link`; a handler here double-counts. */}
    <Button href={getEnrollmentUrl()} className="mt-2 self-start">
      Get started
    </Button>
  </div>
);
